<template >
<div id="TaskList" class="list-container">
	<div class="title-container">
        <div class="search-area">
			<div class="search-item">
                <div class="key">{{$t(/*设备类型*/'device.device_space')}}：</div>
                <div class="value">
                    <el-select v-model="searchForm.space" :placeholder="$t(/*请选择*/'c.select')" @change="pageChange(1)" clearable filterable>
                        <el-option v-for="item of spaceList" :label="$t(item.key)" :value="item.value" :key="item.value"/>
                    </el-select>
                </div>
            </div>
            <div class="search-btn">
                <el-button type="primary" @click="pageChange(1)">{{$t(/*搜索*/'c.search')}}</el-button>
            </div>
        </div>
        <div class="btn-area">
            <EditTask btnType='primary' :btnText="$t(/*新增*/'c.add')+$t(/*任务*/'c.task')" @change='getTableData' v-if="$auth('ADMIN')"/>
        </div>
    </div>
	<div class="table-container">
		<el-table :data="tableData" v-loading='loading'>
			<el-table-column label="ID" min-width="60" prop="id"/>
			<el-table-column :label="$t(/*任务名称*/'task.task_name')" min-width="200" prop="name">
				<template slot-scope="{row}">
					<router-link target="_blank" class="router-link" :to="getRouterLink('detail', row)">{{ row.name }}</router-link>
				</template>
			</el-table-column>
			<el-table-column :label="$t(/*目标版本*/'task.target_version')" min-width="120" prop="target_version"/>
			<el-table-column :label="$t(/*设备类型*/'device.device_space')" min-width="120">
				<template slot-scope="{row}">{{$t($U.deviceSpaceFilter(row.space))}}</template>
			</el-table-column>

			<el-table-column :label="$t(/*计划*/'task.plan')+$t(/*开始时间*/'c.begin_time')" min-width="150">
				<template slot-scope="{row}">{{$U.timeFormat(row.begin_time)}}</template>
			</el-table-column>
			<el-table-column :label="$t(/*计划*/'task.plan')+$t(/*结束时间*/'c.end_time')" min-width="150">
				<template slot-scope="{row}">{{$U.timeFormat(row.end_time)}}</template>
			</el-table-column>
			<el-table-column :label="$t(/*任务状态*/'task.task_status')" width="100">
				<template slot-scope="{row}">{{$t($U.otaTaskStatus(row.status))}}</template>
			</el-table-column>
			<el-table-column :label="$t(/*升级中设备数*/'task.processing_count')" min-width="140" prop="device_count_processing"/>
			<el-table-column :label="$t(/*成功数/总数*/'task.success_total_count')" min-width="160">
				<template slot-scope="{row}">{{row.device_count_success}} / {{row.device_count_total}}</template>
			</el-table-column>
			<el-table-column :label="$t(/*创建时间*/'c.create_time')" min-width="170" prop="create_time">
				<template slot-scope="{row}">{{$U.timeFormat(row.create_time)}}</template>
			</el-table-column>
			<el-table-column :label="$t(/*操作*/'c.operation')" width="150" prop="create_time" fixed="right">
				<template slot-scope="{row}">
					<router-link target="_blank" class="router-link" :to="getRouterLink('detail', row)">{{$t(/*详情*/'c.detail')}}</router-link>
					<template  v-if="$auth('ADMIN')">
						<div class="divide" />
						<EditTask :detail='row' @change='getTableData'/>
						<div class="divide" />
						<el-button type="text danger" @click='handleDelete(row.id)'>{{$t(/*删除*/'c.delete')}}</el-button>
					</template>
				</template>
			</el-table-column>
		</el-table>
	</div>
	<div class="paging-container">
		<el-pagination
			class="text-right"
			@current-change="pageChange"
			:current-page="currPage"
			:page-size="pageSize"
			layout="total, prev, pager, next, jumper"
			:total="total">
		</el-pagination>
	</div>
</div>
</template>

<script type="text/ecmascript-6">
import Core from '../../core'

export default {
	components: {
        EditTask: () => import('./components/EditTask.vue'),
    },
	data() {
		return {
			loading: false,

			// 分页配置
			currPage: 1,
			total: 0,
			pageSize: 10,

			searchForm: {
				space: '',
			},
			spaceList: Object.values(Core.Const.DEVICE.SPACE_MAP),

			tableData: [],
		}
	},
	mounted() {
		this.pageChange(1);
	},
	methods: {
		getRouterLink(key, item = {}) {
            switch (key) {
                case 'detail':
                    return {
                        path: '/task/detail',
                        query: {id: item.id}
                    }
            }
        },
        // 页码变更
		pageChange(val) {
			this.currPage = val;
			this.getTableData();
		},
        // 获取表格数据 - 任务列表
		getTableData() {
			Core.Api.OtaTask.list({
				page: this.currPage,
				space: this.searchForm.space,
			}).then(res => {
				this.total = res.count;
				this.tableData = res.ota_task_list;
			})
		},

		handleDelete(task_id) {
			this.$confirm(this.$t(/*确定要删除该任务吗？*/'task.ask_delete'), this.$t(/*提示*/'c.tip'), {
				confirmButtonText: this.$t(/*确定*/'c.confirm'),
                cancelButtonText: this.$t(/*取消*/'c.cancel'),
				type: 'warning'
			}).then(() => {
				Core.Api.OtaTask.delete({task_id}).then(() => {
					this.$message.success(this.$t(/*操作成功*/'c.oper_success'));
					this.getTableData()
				})
			})
		},
	}
}
</script>

<style scoped lang="scss">
// #TaskList {}
</style>
